import { Button } from '../../elements/trustyle-button'

export default ({ value }) => (
  <Button variant='primary' sx={{ px: 0 }}>
    <span>{value}</span>
  </Button>
)
